var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import { getTypeFromId } from '../../../utils/matchVehicleCategories';
var cx = classnames.bind(style);
function VehicleList(props) {
    var dataList = props.dataList, selected = props.selected, changeVehicleTypeHandler = props.changeVehicleTypeHandler, categoriesType = props.categoriesType;
    return (_jsx("div", __assign({ className: cx('vehicle-list') }, { children: _jsx("ul", { children: _.map(dataList, function (type, index) { return (_jsx("li", __assign({ className: cx({ actived: _.isEqual(selected, type['id']) }) }, { children: _jsxs("div", __assign({ className: cx('item', _.kebabCase(getTypeFromId(type['id'], categoriesType))), onClick: function () {
                        return type['id'] !== selected &&
                            changeVehicleTypeHandler(type['id']);
                    } }, { children: [_jsx("i", {}, void 0), _jsx("span", { children: _.upperFirst(type['name']) }, void 0)] }), void 0) }), index)); }) }, void 0) }), void 0));
}
export default VehicleList;
